import React, { ReactElement } from "react";
import "./ResetSuccess.css";

/**
 * This component renders a success message after password reset
 * and will need to be logic gated by the parent component after a
 * successfull api call to the backend.
 *
 * @returns success message and link to gmail
 *
 * No states, no props
 * App -> Login -> ResetPassword -> ResetSuccess
 */
function ResetSuccess() : ReactElement {
    return (
        <div className="password-reset-container">
            <div className="password-reset shadow-lg border p-4">
                <form className="password-reset-text d-flex flex-column align-items-center">
                    <div className="form-group">
                        <p>
                            If the email you have entered is associated with a Foqal account,
                            then you should receive a password reset link shortly.
                        </p>
                    </div>
                    <a href="https://www.gmail.com">
                        <button type="button" className="reset-button">
                            Open Gmail
                        </button>
                    </a>
                </form>
            </div>
        </div>
    );
}

export default ResetSuccess;
